import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, take, timeout } from 'rxjs/operators';
import { BlogPost } from '../models/blog.models';
import { BlogPostsFirebaseService } from '../services/firebase/blog-posts-firebase.service';

/**
 * Resolver that loads a blog post by slug before rendering the detail page
 * Returns the post or null if not found / on timeout
 */
export const blogPostResolver: ResolveFn<BlogPost | null> = (route: ActivatedRouteSnapshot) => {
  const blogService = inject(BlogPostsFirebaseService);
  const slug = route.paramMap.get('slug') || '';

  return blogService.getBySlug(slug).pipe(
    map((posts) => (posts.length > 0 ? posts[0] : null)),
    take(1),
    timeout(5000),
    catchError(() => of(null)),
  );
};
